import React from "react";
import { Link } from "react-router-dom";
import CTA from "../components/cta";
function Disclaimer()
{
    return (
    <>
  <section
    className="flat-title-page mrg-0 boder-r-0 pdg-btm-60"
    style={{ backgroundImage: "url(images/img/banner-innerpages.jpg)" }}
  >
    <div className="container">
      <div className="breadcrumb-content">
        <h1 className="text-center text-white title">Disclaimer</h1>
        <ul className="breadcrumb">
          <li>
            <a href="/" className="text-white">
              Home
            </a>
          </li>
          <li className="text-white">/Disclaimer</li>
        </ul>
      </div>
    </div>
  </section>
  <section className="flat-section">
    <div className="container">
      <div className="flat-img-with-text">
        <div className="wow fadeInUp" style={{ visibility: "visible" }}>
          <h3 className="title mt-4">Website Terms of Use – Nova Real Estate</h3>
          <p className="desc"></p>
          <p className="mb-15">
            By accessing or using this website (the “Visitor”), you agree to the
            following Terms of Use. These terms form a binding and enforceable
            agreement between you and Nova Real Estate.
          </p>
          <h5 className="mb-15">1. Information &amp; Disclaimer</h5>
          <ul className="list">
            <li>
              All content and materials on this website are provided on an “as
              is” basis, for general guidance only.
            </li>
            <li>
              No warranties, express or implied, are made regarding
              completeness, accuracy, reliability, suitability, or availability
              of the information provided.
            </li>
            <li>
              Accessing or browsing this website does not create any offer,
              contract, or legal obligation between Nova Real Estate and the
              Visitor.
            </li>
            <li>
              Any transaction will be governed solely by the Agreement for Sale
              executed between Nova Real Estate and the concerned party.
            </li>
          </ul>
          <h5 className="mb-15 mt-10">2. External Links</h5>
          <ul className="list">
            <li>
              This website may contain links to third-party or external
              websites. These are provided for convenience and information only.
            </li>
            <li>
              Nova Real Estate does not control, endorse, or guarantee the content,
              accuracy, or availability of linked websites.
            </li>
            <li>
              The Company shall not be responsible or liable for any loss,
              damage, or consequence arising from the use of such linked
              websites.
            </li>
          </ul>
          <h5 className="mb-15 mt-10">3. Governing Law &amp; Jurisdiction</h5>
          <ul className="list">
            <li>
              These Terms of Use shall be governed by and interpreted in
              accordance with the laws of India.
            </li>
            <li>
              The courts of Uttar Pradesh shall have exclusive jurisdiction over
              any dispute or matter arising in relation to the website or these
              terms.
            </li>
          </ul>
          <p />
        </div>
      </div>
    </div>
  </section>
  <CTA/>
</>

    )
}
    export default Disclaimer;